module.exports = __webpack_public_path__ + "static/media/dolly-amza.8b02af97.svg";